import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgPencil = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M4.288 15.678a3.1 3.1 0 0 1 .78-1.315L15.762 3.67a2.254 2.254 0 0 1 3.185 0l1.385 1.386q.163.165.288.353c.577.873.482 2.06-.288 2.83L9.637 18.93c-.046.046-.092.06-.141.134-.338.299-.738.488-1.174.647l-4.23 1.244a.79.79 0 0 1-.835-.242c-.219-.187-.3-.507-.213-.805zm.811 3.224 2.748-.809c.081-.024.162-.087.24-.094l-1.277-.257a.71.71 0 0 1-.552-.552l-.256-1.276a1.5 1.5 0 0 0-.095.239zm4.263-2.085 7.112-7.112-2.21-2.211-7.081 7.144.33 1.817z"
    }));
export default SvgPencil;
